import { IDiscountOffer } from "./discount-offer";

export enum PriceTypesEnum {
    "CLUB" = "CLUB",
    "VIP" = "VIP",
    "SPOT" = "SPOT"
}
export type PriceTypes = keyof typeof PriceTypesEnum;

export enum ProductStatusEnum {
    "NEWS" = "NEWS",
    "BESTSELLER" = "BESTSELLER",
    "SPOT" = "SPOT",
    "BOOK_OF_THE_MONTH" = "BOOK_OF_THE_MONTH",
    "UPCOMING" = "UPCOMING"
}
export type ProductStatus = keyof typeof ProductStatusEnum;

export enum ProductStockStatusEnum {
    "LOW_IN_STOCK" = "warning",
    "OUT_OF_STOCK" = "error"
}

export type ProductStockStatus = keyof typeof ProductStockStatusEnum;

export interface IProductAuthor {
    name: string;
    url?: string;
}

export interface IProductDiscount {
    label?: string;
    value?: string;
}

export interface IProduct {
    productId: string;
    title: string;
    description?: string;
    authors?: IProductAuthor[];
    imageFallbackSrc?: string;
    imageSrcSet?: string;
    priceType?: PriceTypes;
    status?: ProductStatus;
    statusLabel?: string;
    url?: string;
    target?: string;
    isCurrentBookOfTheMonth?: boolean;
    bookOfTheMonthStatusLabel?: string;
    materialType?: string;
    ctaLink?: string;
    primaryPrice?: string;
}

export interface IBasketProduct extends IProduct {
    quantityNumber: number;
    quantity: string;
    discountsModalTitle?: string;
    totalLabel?: string;
    priceLabel?: string;
    discountLabel?: string;
    calculatedPrimaryPrice: string;
    calculatedPrimaryPriceNumber: number;
    calculatedSecondaryPrice?: string;
    calculatedSecondaryPriceNumber?: number;
    isFree?: boolean;
    materialType?: string;
    numberOfProductsLabel?: string;
    deliveryLabel?: string;
    deliveryDetails?: string;
    stockStatus?: ProductStockStatus;
    stockStatusLabel?: string;
    stockStatusDetails?: string;
    discountOffer?: IDiscountOffer;
    primaryPrice?: string;
    primaryPriceNumber?: number;
    secondaryPrice?: string;
    discount?: string;
    discounts?: IProductDiscount[];
}
